var woocommerceCateory = [
  {
    region: 'au',
    categoryParentId: 74,
    glassesProductId: 191,
    frameProductId: 990,
    armProductId: 101,
    homePageId: 2165
  },
  {
    region: 'international',
    categoryParentId: 74,
    glassesProductId: 191,
    frameProductId: 990,
    armProductId: 101,
    homePageId: 2165
  },
  {
    region: 'ca',
    categoryParentId: 17,
    glassesProductId: 191,
    frameProductId: 990,
    armProductId: 101,
    homePageId: 1885
  },
  {
    region: 'nz',
    categoryParentId: 17,
    glassesProductId: 74,
    frameProductId: 92,
    armProductId: 72,
    homePageId: 1612
  }
];

export const getParentCategoryId = (region: any) => {
  if (region) {
    return woocommerceCateory.filter(
      (category: any) => category.region === region
    )[0].categoryParentId;
  }

  return woocommerceCateory[0].categoryParentId;
};

export const getGlassesProductId = (region: any) => {
  if (region) {
    return woocommerceCateory.filter(
      (category: any) => category.region === region
    )[0].glassesProductId;
  }
  return woocommerceCateory[0].glassesProductId;
};

export const getFrameProductId = (region: any) => {
  if (region) {
    return woocommerceCateory.filter(
      (category: any) => category.region === region
    )[0].frameProductId;
  }

  return woocommerceCateory[0].frameProductId;
};

export const getArmProductId = (region: any) => {
  if (region) {
    return woocommerceCateory.filter(
      (category: any) => category.region === region
    )[0].armProductId;
  }

  return woocommerceCateory[0].armProductId;
};

export const getHomePageId = (region: any) => {
  if (region) {
    return woocommerceCateory.filter(
      (category: any) => category.region === region
    )[0].homePageId;
  }

  return woocommerceCateory[0].homePageId;
};
